import React from 'react'
import { NavLink } from 'react-router-dom'
import runningman from '../image/runningman.jpg'

const Varietydetails5 = () => {
  return (
    <div>
        <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden h-screen">
        <NavLink to="https://www.youtube.com/watch?v=s7GmBHaO4Nw"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 p-5" href="https://www.youtube.com/watch?v=s7GmBHaO4Nw">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={runningman} alt="Image Description"/>
      </div>

      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Variety Show
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-600 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          Running Man
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mb-5 mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Variety Show
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>September 20, 2015
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>5
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    <hr class="border-purple-500 mt-5"></hr>

<div>
  <div className='flex justify-center'>
     <h1 className='font-bold text-2xl p-2 text-blue-500'>About the show</h1>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>On September 20, 2015, RM made a solo appearance in episode 265 of the variety show 'Running Man.' The show consists of its resident stars and guests completing missions at various places to win a race. </p>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>'BTS: Yet to Come' will be available to stream on November 9, 2023 in 240 countries and territories worldwide on Prime Video. </p>
  </div>
  <div className='text-2xl font-bold text-blue-500 p-4'>
  APPEARANCES
  </div>
  <div className='text-purple-500 text-xl font-semibold p-1 ml-7'>
      <p>Sep 20, 2015: RM was the first member of BTS to appear on the show making his solo appearance in episode 265. To view a short clip of this episode, visit Kowoca's Facebook website. </p>
<p>May 22, 2016: BTS made a guest appearance on the show for their special 300th episode. The band appeared at the 44-minute mark greeting the Running Man team with a brief dance performance of their song 'Fire'. </p>
<p>Nov 6, 2022: Jin returned to the show making his solo appearance on Episode 626.</p>
<p>Sep 10, 2023: V returned to the show making a solo appearance for episode 670, two days after the release of his solo album 'Layover.'</p>
<p>Dec 3, 2023: V will make another appearance on the show along with actor Yoo Seung Ho. </p>
  </div>
</div>
        </div>
    </div>
  )
}

export default Varietydetails5
